"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AllPageHeaderCheckbox = void 0;
var _react = require("react");
var _Checkbox = _interopRequireDefault(require("@gogame/ui/Checkbox"));
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _IconButton = _interopRequireDefault(require("@gogame/ui/IconButton"));
var _Box = _interopRequireDefault(require("@gogame/ui/Box"));
var _Menu = _interopRequireDefault(require("@gogame/ui/Menu"));
var _MenuItem = _interopRequireDefault(require("@gogame/ui/MenuItem"));
var _Tooltip = _interopRequireDefault(require("@gogame/ui/Tooltip"));
var _Icon = require("@gogame/ui/Icon");
var _styles = require("@gogame/ui/styles");
var _getSelectAllPagesSelector = require("../../utils/getSelectAllPagesSelector");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["checked", "disabled"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    dropdownAnchor: {
      paddingLeft: 0,
      paddingRight: 0,
      borderRadius: '4px',
      width: '16px',
      color: theme.palette.text.icon
    },
    checkbox: {
      '&:hover': {
        background: theme.palette.action.hover
      },
      borderRadius: '4px'
    }
  };
}, {
  name: 'GridHeaderCheckbox'
});
var AllPageHeaderCheckbox = exports.AllPageHeaderCheckbox = /*#__PURE__*/(0, _react.memo)(/*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var checked = _ref.checked,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var apiRef = (0, _xDataGridPro.useGridApiContext)();
  var allPagesSelected = (0, _xDataGridPro.useGridSelector)(apiRef, _getSelectAllPagesSelector.getSelectAllPagesSelector);
  var classes = useStyles();
  var handleToggleAllPages = (0, _react.useCallback)(function () {
    apiRef.current.setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        allPagesSelected: !state.allPagesSelected
      });
    });
    apiRef.current.forceUpdate();
  }, []);
  var title = apiRef.current.getLocaleText(props.checked ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box["default"], {
    gap: 0,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
      title: title,
      wrapper: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], _objectSpread({
        className: classes.checkbox,
        checked: allPagesSelected || checked,
        disabled: allPagesSelected || disabled,
        "data-cy": 'selectAllRowsCheckbox',
        ref: ref
      }, props))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu["default"], {
      anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        disabled: allPagesSelected,
        className: classes.dropdownAnchor,
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ArrowDropDownIcon, {})
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
        onClick: handleToggleAllPages,
        children: "Select All Pages"
      })
    })]
  });
}));
AllPageHeaderCheckbox.displayName = 'AllPageHeaderCheckbox';
var _default = exports["default"] = AllPageHeaderCheckbox;